module.exports = __webpack_public_path__ + "assets/enhancements.c9a7c5b6.svg";